export default __webpack_public_path__ + "static/media/ate2.dd365e27.png";